import axios from 'axios'
const api = axios.create({
    baseURL:
        process.env.REACT_APP_MODE === 'development'
            ? process.env.REACT_APP_API
            : process.env.REACT_APP_G_API,
})

export default api
